import React, { useContext, useEffect } from "react";
import { LoadingContext } from "../../context/LoadingContext";
import { TitleContext } from "../../context/TitleContext";

export const MobileOnly = (props) => {
  const { setTitle } = useContext(TitleContext);
  const { setLoading } = useContext(LoadingContext);

  useEffect(() => {
    setTitle("MOBILE ONLY");
    setLoading(false);
  }, []);

  return (
    <div>
      <h2 className="title " style={{ marginBottom: "16px" }}>
        This promotion is not available on desktop.
      </h2>
      <h2 className="title " style={{ marginBottom: "45px", fontWeight: 400 }}>
        Get with the times, and try again on mobile.{" "}
      </h2>
    </div>
  );
};
